<template>
  <div>
    <!-- Loading Spinner -->
    <module-spinner
      :active="loading"
      :floating="true"
    />

    <transition
      name="fade"
      mode="out-in"
    >
      <div
        v-if="!loading"
      >
        <h3 class="h3 mt0">Dentist Reviewer Request</h3>
        <p class="p">The following dentist requested to become a reviewer:</p>

        <h4 class="h4 mt2">Dentist Details</h4>
        <p class="mt">View: <a :href="request.identity_card" target="_blank" class="c-secondary fw-bold">Uploaded ID Card</a></p>
        <p class="mt">View: <a :href="request.dental_license" target="_blank" class="c-secondary fw-bold">Uploaded Dental License</a></p>
        <p class="mt mb2">View: <a :href="request.specialty_certificate" target="_blank" class="c-secondary fw-bold">Uploaded Speciality Certificate</a></p>
        <module-detail-list
          :items="{
            'Title:': `Dr`,
            'First Name:': request.doctor.first_name,
            'Last Name:': request.doctor.last_name,
            'Email Address:': request.doctor.email,
            'License Number:': request.doctor.profile.license_number,
            'Phone Number:': request.doctor.profile.phone_number,
            'Speciality:': reviewNomenclatureBySlugAndId(`specialties`, request.doctor.profile.specialty),
          }"
        />
        <div
          v-for="(location, index) in request.doctor.clinics"
          :key="index"
        >
          <h4 class="h4 mt2">Location {{ index + 1 }}</h4>
          <module-detail-list
            :items="{
              'Address Line One': location.address_1,
              'Address Line Two': location.address_2,
              'City': location.city,
              'State': location.state,
              'ZIP': location.zipcode,
            }"
          />
        </div>
        <div v-if="request.status === 1 || request.status === 3">
          <module-button
            class="mr2"
            size="m"
            button="primary"
            label="approve"
            :loading="buttonLoading === `approve`"
            :disabled="buttonLoading === `deny`"

            @click.native="approve(true)"
          />
          <module-button
            v-if="request.status === 1"
            size="m"
            button="primary"
            label="refuse"
            :loading="buttonLoading === `deny`"
            :disabled="buttonLoading === `approve`"

            @click.native="approve(false)"
          />
        </div>
        <p v-else class="fw-bold mt2">This request has already been completed</p>
      </div>
    </transition>
  </div>
</template>

<script>

// Vuex
import { mapActions, mapGetters } from 'vuex';

// Modules
import ModuleDetailList from 'modules/DetailList';
import ModuleButton from 'modules/Button';
import ModuleSpinner from 'modules/Spinner';

// Export
export default {
  name: `reviewer-request`,

  // Components
  components: {
    ModuleButton,
    ModuleDetailList,
    ModuleSpinner,
  },

  // Data
  data() {
    return {
      loading: true,
      buttonLoading: ``,
      request: {},
    };
  },

  computed: {
    ...mapGetters(`review`, [
      `reviewNomenclatureBySlugAndId`,
    ]),
    id() {
      return this.$route.params.id;
    },
  },

  // Methods
  methods: {
    ...mapActions(`reviewer`, [
      `getReviewerRequestById`,
      `submitReviewerRequestDecision`,
    ]),
    approve(decision) {
      this.buttonLoading = decision ? `approve` : `deny`;
      return this.submitReviewerRequestDecision({
        id: this.id,
        approved: decision,
      })
        .then(() => {
          this.buttonLoading = ``;
          this.$nextTick(this.$router.push({
            name: `success`,
            params: {
              page: decision ? `reviewer-approved` : `reviewer-denied`,
              doctorName: `Dr ${this.request.doctor.first_name} ${this.request.doctor.last_name}`,
            },
          }));
        })
        .catch(() => {
          this.buttonLoading = ``;
        });
    },
  },

  // Lifecycle
  created() {
    this.getReviewerRequestById(this.id)
      .then(res => {
        this.loading = false;

        this.$set(this, `request`, res.data || {});
      });
  },
};
</script>



// WEBPACK FOOTER //
// ReviewerRequest.vue?6ecbbfc8